import React, { useState } from "react";
import Modal from "./Modal";

function INELTable({ head, apiResponse, setApiResponse, activeResultTab }) {
  console.log("apiResponse", apiResponse);
  const [item, setItem] = useState();
  const [product, setProduct] = useState();
  const [show, setShow] = useState(false);

  const handleProductClick = (productKey) => {
    console.log(productKey);
    // Retrieve the entire object corresponding to the selected product key
    const selectedItem = apiResponse["Ineligible products"][productKey];
    setItem(selectedItem); // Set the selected product object
    console.log(selectedItem);
    setShow(true); // Show the modal
  };

  return (
    <>
      {/* Table for Ineligible */}
      <>
        <h1 className="text-[#037DFA] text-2xl font-bold">{head}</h1>
        <div className="parent py-10 rounded-3xl  mt-10 border h-[50vh] overflow-y-scroll	">
          <p className="px-5">
            All values are estimates based on the information provided.
          </p>
          <header className="sticky bg-slate-50 h-16 z-20 top-[-40px]  mt-7  rounded-t-lg text-white text-base border-gray-200">
            {/* <caption className="px-6 font-semibold w-96">{title}</caption> */}
            <div className="flex font-Poppins bg-[#0065cc]">
              <div className="w-1/3 text-white text-xl font-semibold px-6 py-3">
                Investor
              </div>
              <div className="w-1/3 text-white text-xl font-semibold px-6 py-3">
                Product
              </div>
              {/* <div className="w-1/3 px-6 py-3">Reasons</div> */}
            </div>
          </header>
          <div className=" relative overflow-x-auto  ">
            <div className="w-full text-sm text-left rtl:text-right text-gray-500">
              <div className="bg-blue-300 w-full">
                {apiResponse["Ineligible products"] === 0 && (
                  <p className="bg-gray-50 text-black text-3xl font-semibold   text-center py-2">
                    No Ineligable Product
                  </p>
                )}
                {apiResponse["Ineligible products"] &&
                  Object.keys(apiResponse["Ineligible products"]).map(
                    (productKey, index) => {
                      console.log(productKey);
                      return (
                        <div
                          key={index}
                          className={"odd:bg-white even:bg-slate-50"}
                        >
                          <div className="flex">
                            <div className="w-1/3 p-8 max-[600px]:p-4 font-medium text-gray-900 whitespace-nowrap">
                              Quantic Bank
                            </div>
                            <div
                              onClick={() => {
                                handleProductClick(productKey);
                                setProduct(productKey);
                              }}
                              className={`w-1/3 p-8 text-gray-900 max-[600px]:p-4 max-[600px]:w-[100%] cursor-pointer decoration-solid `}
                            >
                              {productKey}
                            </div>
                            <div className="w-1/3 p-8 max-[600px]:p-4 max-[600px]:w-[100%] cursor-pointer decoration-solid"></div>
                          </div>
                        </div>
                      );
                    }
                  )}
              </div>
            </div>
          </div>
        </div>
        {show && (
          <div>
            <Modal
              show={show}
              setShow={setShow}
              item={item}
              product={product}
            />
          </div>
        )}
      </>
    </>
  );
}

export default INELTable;
